export class ClassCommentsManagment {
    constructor(config) {
        this.comment = config.comment;
        this.commentText = this.comment.querySelector(config.commentText);
        this.commentTextBtn = this.comment.querySelector(config.commentTextBtn);
        
        this.commentsBlock = this.comment.querySelector(config.commentsBlock);
        this.dispCommentsBtn = this.commentsBlock.querySelector(config.dispCommentsBtn);
        
        this.newCommentBlock = this.commentsBlock.querySelector(config.newCommentBlock);
        this.newCommentAddBtn = this.commentsBlock.querySelector(config.newCommentAddBtn);
        this.newCommentCloseBtn = this.commentsBlock.querySelector(config.newCommentCloseBtn);

        this.reviewsCommentsBody = this.commentsBlock.querySelector(config.reviewsCommentsBody);
        this.subCommentsBlock = config.subCommentsBlock;
        this.subCommentsItem = config.subCommentsItem;
        this.subCommentsForm = config.subCommentsForm;
        this.subCommentsAddBtn = config.subCommentsAddBtn;
        this.subCommentsShowBtn = config.subCommentsShowBtn;
        this.subCommentsCloseBtn = config.subCommentsCloseBtn;
        this.subCommentsSendBtn = config.subCommentsSendBtn;
        this.commentsCount = this.comment.querySelector(config.commentsCount);
        this.getReviewsComments = config.getReviewsComments;
        this.sendReviewsComment = config.sendReviewsComment;
        this.totalComments = null;

    }
    
    renderComments(data) {
        data.forEach(item => {
            if (!item) return;

            const commentBlock = document.createElement('div');
            commentBlock.classList.add('comments-item');

            commentBlock.append(this.renderMainComment(item));
            
            commentBlock.append(this.renderSubComments(item.ID,item.SUB_COMMENTS));

            this.reviewsCommentsBody.append(commentBlock);
        })
    }

    renderMainComment(item) {
        const mainComment = document.createElement('div');
        mainComment.classList.add('comments-item__comment', 'review-comment');

        mainComment.innerHTML = `
            <div class="review-comment__avatar">
                <img class="avatar" src="/local/templates/taganrogotoplenie/img/user-icon.png" alt="">
            </div>

            <div class="review-comment__info">
                <span class="review-comment__name">
                    <span>${item.USER_NAME?item.USER_NAME : `Пользователь_${item.ID_USER}`}</span>
                    <span>${item.DATE_CREATE?item.DATE_CREATE.split(' ')[0] : ''}</span>
                </span>
                <span class="review-comment__text">${item.MESSAGE?item.MESSAGE : ''}</span>
            </div>`;

        return mainComment;
    }

    renderSubComments(ID, subcomments) { 
        const subcommentsBlock = document.createElement('div');
        subcommentsBlock.classList.add('comments-item__subcomments');

        if (!!subcomments && subcomments.length) {
            subcomments.forEach(item => {
                subcommentsBlock.append(this.renderSubCommentsItem(item));
            })
        }

        subcommentsBlock.append(this.renderSubCommentsBtns(subcommentsBlock));
        subcommentsBlock.append(this.renderSubCommentsForm(ID));

        this.evSubCommentsItems(subcommentsBlock);

        return subcommentsBlock;
    }

    renderSubCommentsItem(item) {
        const reviewSubComment = document.createElement('div');
        reviewSubComment.classList.add('review-comment');
    
        reviewSubComment.innerHTML = `
            <div class="review-comment__avatar">
                <img class="avatar" src="/local/templates/taganrogotoplenie/img/user-icon.png" alt="">
            </div>
    
            <div class="review-comment__info">
                <span class="review-comment__name">
                    <span>${item.USER_NAME?item.USER_NAME : `Пользователь_${item.ID_USER}`}</span>
                    <span>${item.DATE_CREATE.split(' ')[0]}</span>
                </span>
                <span class="review-comment__text">${item.MESSAGE}</span>
            </div>`;

        return reviewSubComment;
    }

    renderSubCommentsBtns(subcommentsBlock) {
        const switchBtns = document.createElement('div');
        switchBtns.classList.add('comments-item__switch-btn');

        switchBtns.innerHTML = `
            <span class="reviews-btn reviews-btn_add" data-toggle="modal" data-target="#auth">Ответить на комментарий</span>
            <span class="reviews-btn reviews-btn_switch" data-is-show="0">Показать все ответы</span>`;

        const btnShowComments  = switchBtns.querySelector('.reviews-btn_switch');

        btnShowComments.addEventListener('click', () => this.evBtnShowAllSubComments(btnShowComments, subcommentsBlock));

        return switchBtns;
    }

    renderSubCommentsForm(ID) {
        const subcommentForm = document.createElement('form');
        subcommentForm.classList.add('new-comment__form');

        subcommentForm.setAttribute('data-parent-id', ID);

        subcommentForm.innerHTML = `
            <div class="new-comment__avatar">
                <img class="avatar" src="/local/templates/taganrogotoplenie/img/user-icon.png" alt="">
            </div>

            <div class="new-comment__interaction">
                <div class="new-comment__header">
                    <span>Вы</span>
                    <div class="new-comment__close">
                        <svg class="icon-fluid">
                            <use xlink:href="/local/templates/taganrogotoplenie/dist/img/icons/icons.svg#icon-close"></use>
                        </svg>
                    </div>
                </div>

                <div class="new-comment__input">
                    <input type="text" placeholder="Напишите комментарий">

                    <span class="new-comment__public-rules">
                        Перед отправкой комментария, пожалуйста, ознакомьтесь с <a href="#">правилами публикации</a>
                    </span>
                </div>

                <div class="new-comment__btn-send">
                    <button class="btn btn_regular btn_info" type="button">ОТПРАВИТЬ</button>
                </div>
            </div>
        `;

        return subcommentForm;
    }

    handlerDispAddNewComment() {
        this.newCommentBlock.classList.toggle('new-comment_close');
    }

    handlerDispSubComments(subcommentsBlock, val) {
        const comments =  Array.from(subcommentsBlock.querySelectorAll(this.subCommentsItem));

        comments.forEach((item, index) => {
            if(index > 1) {
                val == 0 ? item.classList.remove('review-comment_hide') : item.classList.add('review-comment_hide');
            }
        })
    }

    handlerDisplaySubComment(form) {
        form.classList.toggle('new-comment__form_show');
    }

    evDispCommentsBtn() {
        this.dispCommentsBtn.addEventListener('click', async () => {
            const id = this.commentsBlock.getAttribute('data-reviews-id');

            if (!this.commentsBlock.classList.contains('reviews-comments_open-comments')) {
                this.commentsBlock.classList.toggle('reviews-comments_open-comments');
                this.reviewsCommentsBody.innerHTML = '';
                return;
            }

            await this.getReviewsComments(id).then(res => {
                const data = res.result;
                this.totalComments = res.total;
                if (data.length) this.renderComments(data);

                this.commentsBlock.classList.toggle('reviews-comments_open-comments');
            })
        })
    }

    evNewCommentAddBtn() {
        this.newCommentAddBtn.addEventListener('click', async()=>  {

            const buttonComment = document.querySelector('.new-comment__btn-add').getAttribute('data-target');
            if(buttonComment == '#review1')  this.handlerDispAddNewComment();
        })
    }

    evNewCommentCloseBtn() {
        this.newCommentCloseBtn.addEventListener('click', (ev)=> {
            ev.preventDefault();
            ev.stopPropagation();
            this.handlerDispAddNewComment();
        })
    }

    evCommentTextBtn() {
        if (this.commentText.textContent.length < 310) return;

        this.commentTextBtn.classList.add('desc-btn_show');

        this.commentTextBtn.addEventListener('click', () => {
            this.commentText.classList.toggle('desc-text-hide');

            this.commentTextBtn.textContent = this.commentTextBtn.textContent === 'Скрыть' ? 'Читать полностью' : 'Скрыть';
        })
    }

    evFormSubmitComment() {
        const formRev = this.newCommentBlock.querySelector('form');
        const btn = formRev.querySelector('.btn_regular');

        btn.addEventListener('click', async (ev)=> {
            ev.preventDefault();
            const input = formRev.querySelector('input[type="text"]');

            const body = {
                ID_REVIEW: this.commentsBlock.getAttribute('data-reviews-id'),
                ID_USER:  this.commentsBlock.getAttribute('data-user-id'),
                MESSAGE: String(input.value).trim(),
            }

            await this.sendReviewsComment(body).then(res=> {
                this.renderComments([res.result]);
                this.handlerDispAddNewComment();
                input.value = '';
                this.totalComments += 1;
                this.commentsCount.textContent = `Комментарии (${this.totalComments})`;
            })
        })
    }

    evSendFormSubCommit(subCommentsBlock, reviewForm) {
        const btnSendForm = reviewForm.querySelector(this.subCommentsSendBtn);
        const input = reviewForm.querySelector('input[type="text"]');
        const blockPrevent = subCommentsBlock.querySelector('.comments-item__switch-btn');

        btnSendForm.addEventListener('click', async (ev)=> {
            ev.preventDefault();
            
            const body = {
                ID_REVIEW: this.commentsBlock.getAttribute('data-reviews-id'),
                ID_USER: this.commentsBlock.getAttribute('data-user-id'),
                ID_PARENT: reviewForm.getAttribute('data-parent-id'),
                MESSAGE: String(input.value).trim(),
            }

            await this.sendReviewsComment(body).then(res=> {
                if (res.error) return;

                if (res.result) {
                    subCommentsBlock.insertBefore(this.renderSubCommentsItem(res.result), blockPrevent);
                    this.handlerDisplaySubComment(reviewForm);
                    input.value = '';
                    this.totalComments += 1;
                    this.commentsCount.textContent = `Комментарии (${this.totalComments})`;
                    this.handelEvBtnShowAllSubComments(subCommentsBlock, 1);
                }
            })
        })
    }
    
    handelEvBtnShowAllSubComments(subCommentsBlock, val) {
        const reviewComment = Array.from(subCommentsBlock.querySelectorAll(this.subCommentsItem));
        const btnShowComments = subCommentsBlock.querySelector(this.subCommentsShowBtn);

        if (reviewComment.length > 2) {
            btnShowComments.classList.add('reviews-btn_show');
            btnShowComments.setAttribute('data-is-show', val);

            this.evBtnShowAllSubComments(btnShowComments, subCommentsBlock);
        }
    }

    evBtnShowAllSubComments(target, subcommentsBlock) {
        const isShow = target.getAttribute('data-is-show');
        const newIsShow = isShow == 0 ? 1 : 0;

        this.handlerDispSubComments(subcommentsBlock, newIsShow);

        target.textContent = newIsShow == 1 ? 'Показать все ответы' : 'Скрыть ответы';
        target.setAttribute('data-is-show', newIsShow);
    }

    evSubCommentsItems(subCommentsBlock) {       
        const reviewForm = subCommentsBlock.querySelector(this.subCommentsForm);

        this.handelEvBtnShowAllSubComments(subCommentsBlock, 0);
        this.evSendFormSubCommit(subCommentsBlock, reviewForm);

        this.evbtnAddSubComment(subCommentsBlock, reviewForm);
        this.evbtnCloseSubCommentForm(subCommentsBlock, reviewForm);
    }

    evbtnAddSubComment(subCommentsBlock, reviewForm) {
        const btnAddComment = subCommentsBlock.querySelector(this.subCommentsAddBtn);

        btnAddComment.addEventListener('click', () => {

            const buttonComment = document.querySelector('.new-comment__btn-add').getAttribute('data-target');

            if(buttonComment == '#review1') {
                this.handlerDisplaySubComment(reviewForm);

                btnAddComment.removeAttribute('data-target');
            }
        })
    }

    evbtnCloseSubCommentForm(subCommentsBlock, reviewForm) {
        const btnCloseForm = subCommentsBlock.querySelector(this.subCommentsCloseBtn);

        btnCloseForm.addEventListener('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            this.handlerDisplaySubComment(reviewForm);
        })
    }

    init() {
        this.evDispCommentsBtn();
        this.evNewCommentAddBtn();
        this.evNewCommentCloseBtn();
        this.evCommentTextBtn();
        this.evFormSubmitComment();
    }
}

function initModalReviewsInputFile () {
    const modal = document.querySelector('#review');

    if (!modal) return;

    const inputs = modal.querySelectorAll('.form-reviews-input-file');

    if (!inputs.length) return;

    const formItem = inputs[0].parentNode;
    formItem.style.display = 'flex';

    inputs.forEach(item => {
        const input = item.querySelector('input[type="file"]');
        const image = item.querySelector('.form-reviews-input-file__img');
        
        input.addEventListener('change', ()=> {
                const currFile = input.files[0];
                if (currFile) {
                    image.src = URL.createObjectURL(currFile);
                    image.style.display = 'block';
                } else {
                    image.src = '';
                    image.style.display = 'none';
                }
        });
    })
}

export const initCommentsClass = (page) => {
    const commentsArr = page.querySelectorAll('.reviews-item');

    if (!commentsArr.length) return;

    const getComments = async (id) => {
        try {
            const response = await fetch(`/rest/api.comments.get?ID_REVIEW=${id}`);

            return response.json();

        } catch (err) {
            console.log(err)
        }
    }

    const sendComment = async (body) => {
        try {
            const response = await fetch('/rest/api.comments.update', {
                method: 'POST',
                headers: { 'Content-type': 'application/json'},
                body: JSON.stringify(body)
            });

            return response.json();

        } catch(err) {
            console.log(err)
        }
    }

    try {
        commentsArr.forEach(element => {
            new ClassCommentsManagment({
                comment: element,
                commentText: '.reviews-item__desc-text',
                commentTextBtn: '.reviews-item__desc-btn',
                commentsBlock: '.reviews-item__comments',
                dispCommentsBtn: '.reviews-comments__popup-switch',
                newCommentBlock: '.reviews-comments__new-comment',
                newCommentAddBtn: '.new-comment__btn-add',
                newCommentCloseBtn: '.new-comment__close',
                reviewsCommentsBody: '.reviews-comments__body',
                subCommentsBlock: '.comments-item__subcomments',
                subCommentsItem: '.review-comment',
                subCommentsForm: '.new-comment__form',
                subCommentsAddBtn: '.reviews-btn_add',
                subCommentsShowBtn: '.reviews-btn_switch',
                subCommentsCloseBtn: '.new-comment__close',
                subCommentsSendBtn: '.btn_regular',
                commentsCount: '.reviews-comments__count',
                getReviewsComments: getComments,
                sendReviewsComment: sendComment
            }).init();
        });
    } catch(err) {
        console.log(err)
    }
}

(function (){
    const reviewPage = document.querySelector('.reviews-page');

    if (!reviewPage) return;

    initModalReviewsInputFile();
    initCommentsClass(reviewPage);
}());
